(function () {
  function formatWithDelimiters(number, precision, thousands, decimal) {
    const safePrecision = Number.isFinite(precision) ? precision : 2;
    const parts = (number / 100).toFixed(safePrecision).split('.');
    const dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    const cents = parts[1] ? decimal + parts[1] : '';
    return dollars + cents;
  }

  function formatMoney(cents, format) {
    const moneyFormat = format || window.theme?.moneyFormat || '€{{amount_with_comma_separator}}';
    const value = Number(cents || 0);
    const placeholder = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
    const token = placeholder ? placeholder[1] : 'amount';
    let formatted;

    switch (token) {
      case 'amount':
        formatted = formatWithDelimiters(value, 2, ',', '.');
        break;
      case 'amount_no_decimals':
        formatted = formatWithDelimiters(value, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        formatted = formatWithDelimiters(value, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        formatted = formatWithDelimiters(value, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        formatted = formatWithDelimiters(value, 2, "'", '.');
        break;
      default:
        formatted = formatWithDelimiters(value, 2, '.', ',');
    }

    return moneyFormat.replace(placeholder ? placeholder[0] : '{{amount}}', formatted);
  }

  window.theme = window.theme || {};
  window.theme.formatMoney = window.theme.formatMoney || formatMoney;
  const menuContextStorageKey = 'indartxuMenuContext';
  const collectionCatsPositionStorageKey = 'indartxuCollectionCatsPosition';

  function escapeHTML(value) {
    return String(value || '').replace(/[&<>"']/g, (character) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    })[character]);
  }

  function normalizeMenuContext(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function menuContextAliases(value) {
    const normalized = normalizeMenuContext(value);
    const aliasGroups = [
      ['dog', 'perro', 'perros'],
      ['cat', 'gato', 'gatos'],
      ['brand', 'indar', 'gama-indar', 'gama']
    ];
    const match = aliasGroups.find((group) => group.includes(normalized));
    return new Set(match || [normalized]);
  }

  function menuContextsMatch(first, second) {
    if (!first || !second) return false;
    const firstAliases = menuContextAliases(first);
    const secondAliases = menuContextAliases(second);
    return Array.from(firstAliases).some((value) => secondAliases.has(value));
  }

  function readMenuContext() {
    try {
      const stored = window.localStorage.getItem(menuContextStorageKey);
      if (!stored) return null;
      const context = JSON.parse(stored);
      if (!context || !context.expires || context.expires < Date.now()) {
        window.localStorage.removeItem(menuContextStorageKey);
        return null;
      }
      return context;
    } catch (error) {
      return null;
    }
  }

  function writeMenuContext(element) {
    const group = element.dataset.menuContext || element.dataset.collectionMenuGroup;
    const branch = element.dataset.menuBranch || element.dataset.collectionMenuBranch;
    if (!group && !branch) return;
    try {
      const url = new URL(element.getAttribute('href') || window.location.href, window.location.origin);
      window.localStorage.setItem(menuContextStorageKey, JSON.stringify({
        group: normalizeMenuContext(group),
        branch: branch || '',
        path: url.pathname,
        expires: Date.now() + 1000 * 60 * 60 * 6
      }));
    } catch (error) {
      return;
    }
  }

  function updateCollectionCatOverflow(wrap) {
    if (!wrap) return;
    const carousel = wrap.querySelector('[data-collection-cats-carousel]');
    const previous = wrap.querySelector('[data-collection-cats-prev]');
    const next = wrap.querySelector('[data-collection-cats-next]');
    if (!carousel || !previous || !next) return;
    window.requestAnimationFrame(() => {
      const hasOverflow = carousel.scrollWidth > carousel.clientWidth + 3;
      previous.hidden = !hasOverflow;
      next.hidden = !hasOverflow;
    });
  }

  function collectionCatsPositionKey(branch, group) {
    return branch || normalizeMenuContext(group) || 'default';
  }

  function readCollectionCatsPosition(branch, group) {
    try {
      const stored = window.localStorage.getItem(collectionCatsPositionStorageKey);
      if (!stored) return null;
      const positions = JSON.parse(stored);
      const keys = [
        collectionCatsPositionKey(branch, group),
        normalizeMenuContext(group),
        'default'
      ].filter(Boolean);
      const position = keys.map((key) => positions?.[key]).find((item) => item && item.expires && item.expires >= Date.now());
      if (!position || !position.expires || position.expires < Date.now()) return null;
      return Number(position.left) || 0;
    } catch (error) {
      return null;
    }
  }

  function writeCollectionCatsPosition(carousel, branch, group) {
    if (!carousel) return;
    try {
      const stored = window.localStorage.getItem(collectionCatsPositionStorageKey);
      const positions = stored ? JSON.parse(stored) : {};
      const position = {
        left: carousel.scrollLeft,
        expires: Date.now() + 1000 * 60 * 60 * 6
      };
      positions[collectionCatsPositionKey(branch, group)] = position;
      const groupKey = normalizeMenuContext(group);
      if (groupKey) positions[groupKey] = position;
      positions.default = position;
      window.localStorage.setItem(collectionCatsPositionStorageKey, JSON.stringify(positions));
    } catch (error) {
      return;
    }
  }

  function getCollectionCatsContext(collectionCats, fallbackElement) {
    const visibleChip = collectionCats?.querySelector('.collection-chip[data-collection-menu-branch]:not([hidden])');
    return {
      branch: collectionCats?.dataset.activeMenuBranch || fallbackElement?.dataset.collectionMenuBranch || visibleChip?.dataset.collectionMenuBranch || '',
      group: fallbackElement?.dataset.collectionMenuGroup || visibleChip?.dataset.collectionMenuGroup || ''
    };
  }

  function restoreCollectionCatsPosition(carousel, left) {
    if (!carousel || left === null) return;
    const restore = () => {
      carousel.scrollLeft = Math.min(left, Math.max(0, carousel.scrollWidth - carousel.clientWidth));
    };
    window.requestAnimationFrame(() => {
      restore();
      window.requestAnimationFrame(restore);
      window.setTimeout(restore, 180);
    });
  }

  function resolveCollectionMenuBranch(chips, context) {
    const branches = new Set(chips.map((chip) => chip.dataset.collectionMenuBranch).filter(Boolean));
    if (branches.size <= 1) return null;

    if (context?.branch && branches.has(context.branch)) return context.branch;

    if (context?.group) {
      const activeMatch = chips.find((chip) => chip.classList.contains('is-active') && menuContextsMatch(chip.dataset.collectionMenuGroup, context.group));
      if (activeMatch?.dataset.collectionMenuBranch) return activeMatch.dataset.collectionMenuBranch;

      const groupMatch = chips.find((chip) => menuContextsMatch(chip.dataset.collectionMenuGroup, context.group));
      if (groupMatch?.dataset.collectionMenuBranch) return groupMatch.dataset.collectionMenuBranch;
    }

    const active = chips.find((chip) => chip.classList.contains('is-active') && chip.dataset.collectionMenuBranch);
    return active?.dataset.collectionMenuBranch || chips.find((chip) => chip.dataset.collectionMenuBranch)?.dataset.collectionMenuBranch || null;
  }

  function initMenuContextTracking(root) {
    const scope = root || document;
    scope.querySelectorAll('a[data-menu-context], a[data-menu-branch], a[data-collection-menu-branch]').forEach((link) => {
      if (link.dataset.menuContextBound === 'true') return;
      link.dataset.menuContextBound = 'true';
      const persistContext = () => {
        writeMenuContext(link);
        const collectionCats = link.closest('.collection-cats');
        const carousel = collectionCats?.querySelector('[data-collection-cats-carousel]');
        if (carousel) {
          const context = getCollectionCatsContext(collectionCats, link);
          writeCollectionCatsPosition(carousel, context.branch, context.group);
        }
      };
      link.addEventListener('pointerdown', persistContext);
      link.addEventListener('click', persistContext);
    });
  }

  function initCollectionMenuContext(root) {
    const scope = root || document;
    scope.querySelectorAll('.collection-cats').forEach((collectionCats) => {
      const chips = Array.from(collectionCats.querySelectorAll('.collection-chip[data-collection-menu-branch]'));
      if (chips.length === 0) return;
      const targetBranch = resolveCollectionMenuBranch(chips, readMenuContext());
      chips.forEach((chip) => {
        chip.hidden = Boolean(targetBranch && chip.dataset.collectionMenuBranch !== targetBranch);
      });
      collectionCats.dataset.activeMenuBranch = targetBranch || '';
      updateCollectionCatOverflow(collectionCats);
      const targetGroup = chips.find((chip) => !chip.hidden)?.dataset.collectionMenuGroup;
      const savedLeft = readCollectionCatsPosition(targetBranch, targetGroup);
      const carousel = collectionCats.querySelector('[data-collection-cats-carousel]');
      restoreCollectionCatsPosition(carousel, savedLeft);
    });
  }

  function initInputMode() {
    if (document.documentElement.dataset.inputModeBound === 'true') return;
    document.documentElement.dataset.inputModeBound = 'true';

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Tab') {
        document.documentElement.classList.add('is-using-keyboard');
      }
    });

    document.addEventListener('pointerdown', () => {
      document.documentElement.classList.remove('is-using-keyboard');
    });
  }

  function getFocusableElements(container) {
    if (!container) return [];
    return Array.from(container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'))
      .filter((element) => element instanceof HTMLElement && element.offsetParent !== null);
  }

  function trapFocus(event, container) {
    if (event.key !== 'Tab' || !container) return false;
    const focusable = getFocusableElements(container);
    if (focusable.length === 0) return false;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
      return true;
    }
    if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
      return true;
    }
    return false;
  }

  function initMobileMenu(root) {
    const scope = root || document;

    scope.querySelectorAll('[data-menu-open]').forEach((button) => {
      const menu = document.getElementById(button.getAttribute('aria-controls'));
      if (!menu || button.dataset.bound === 'true') return;
      button.dataset.bound = 'true';
      button.addEventListener('click', () => {
        menu.classList.add('is-open');
        menu.setAttribute('aria-hidden', 'false');
        button.setAttribute('aria-expanded', 'true');
        menu.dataset.previousFocus = `[aria-controls="${menu.id}"]`;
        document.body.style.overflow = 'hidden';
        window.requestAnimationFrame(() => {
          menu.querySelector('[data-menu-close], a, button, summary')?.focus({ preventScroll: true });
        });
      });
    });

    scope.querySelectorAll('[data-menu-close]').forEach((button) => {
      if (button.dataset.bound === 'true') return;
      button.dataset.bound = 'true';
      button.addEventListener('click', () => {
        closeMobileMenu(button.closest('[data-mobile-menu]'));
      });
    });

    scope.querySelectorAll('[data-mobile-menu]').forEach((menu) => {
      if (menu.dataset.linksBound === 'true') return;
      menu.dataset.linksBound = 'true';
      menu.addEventListener('click', (event) => {
        const link = event.target.closest('a[href]');
        if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (link.getAttribute('href') === '#' || link.target === '_blank') return;
        closeMobileMenu(menu);
      });
    });
  }

  function resetMobileMenuPanels(menu) {
    if (!menu) return;
    menu.classList.remove('has-panel');
    menu.querySelectorAll('[data-mobile-panel]').forEach((panel) => {
      panel.classList.remove('is-active');
      panel.setAttribute('aria-hidden', 'true');
    });
    menu.querySelectorAll('[data-mobile-panel-target]').forEach((button) => {
      button.setAttribute('aria-expanded', 'false');
    });
  }

  function initMobileMenuPanels(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-mobile-panel-target]').forEach((button) => {
      if (button.dataset.bound === 'true') return;
      button.dataset.bound = 'true';
      button.addEventListener('click', () => {
        const menu = button.closest('[data-mobile-menu]');
        const panel = menu?.querySelector(`[data-mobile-panel="${button.dataset.mobilePanelTarget}"]`);
        if (!menu || !panel) return;
        resetMobileMenuPanels(menu);
        menu.classList.add('has-panel');
        panel.classList.add('is-active');
        panel.setAttribute('aria-hidden', 'false');
        button.setAttribute('aria-expanded', 'true');
        window.requestAnimationFrame(() => {
          panel.querySelector('[data-mobile-panel-back], a, button')?.focus({ preventScroll: true });
        });
      });
    });

    scope.querySelectorAll('[data-mobile-panel-back]').forEach((button) => {
      if (button.dataset.bound === 'true') return;
      button.dataset.bound = 'true';
      button.addEventListener('click', () => {
        const menu = button.closest('[data-mobile-menu]');
        resetMobileMenuPanels(menu);
        menu?.querySelector('[data-mobile-panel-target]')?.focus({ preventScroll: true });
      });
    });
  }

  function initFooterAccordions(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-footer-toggle]').forEach((button) => {
      const syncState = () => {
        const item = button.closest('.footer__menu');
        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        if (!item) return;
        if (!isMobile) {
          item.classList.remove('is-open');
          button.setAttribute('aria-expanded', 'true');
        } else {
          button.setAttribute('aria-expanded', item.classList.contains('is-open') ? 'true' : 'false');
        }
      };

      syncState();
      if (button.dataset.bound === 'true') return;
      button.dataset.bound = 'true';
      button.addEventListener('click', () => {
        const item = button.closest('.footer__menu');
        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        if (!item) return;
        if (!isMobile) {
          button.setAttribute('aria-expanded', 'true');
          return;
        }
        const isOpen = item.classList.toggle('is-open');
        button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
      const handleResize = () => {
        if (!document.contains(button)) {
          window.removeEventListener('resize', handleResize);
          return;
        }
        syncState();
      };
      window.addEventListener('resize', handleResize);
    });
  }

  function initQuantity(root) {
    const scope = root || document;
    scope.querySelectorAll('quantity-input').forEach((quantity) => {
      if (quantity.closest('cart-drawer, [data-main-cart]')) return;
      if (quantity.dataset.bound === 'true') return;
      quantity.dataset.bound = 'true';
      const input = quantity.querySelector('input');
      const min = Number(input?.getAttribute('min') || 1);
      quantity.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
        input.value = Math.max(min, Number(input.value || min || 1) - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      quantity.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
        input.value = Math.max(min, Number(input.value || min || 1)) + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  function initFilters(root) {
    const scope = root || document;
    const isMobileFilters = () => window.matchMedia('(max-width: 749px)').matches;
    scope.querySelectorAll('[data-filter-open]').forEach((button) => {
      if (button.dataset.bound === 'true') return;
      button.dataset.bound = 'true';
      button.addEventListener('click', () => {
        const drawer = button.getAttribute('aria-controls')
          ? document.getElementById(button.getAttribute('aria-controls'))
          : document.querySelector('[data-filter-drawer]');
        if (!drawer) return;
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        drawer.dataset.previousFocus = `[data-filter-open][aria-controls="${drawer.id}"]`;
        document.querySelectorAll(`[data-filter-open][aria-controls="${drawer.id}"]`).forEach((trigger) => {
          trigger.setAttribute('aria-expanded', 'true');
        });
        document.body.style.overflow = 'hidden';
        window.requestAnimationFrame(() => {
          drawer.querySelector('[data-filter-close], input, select, button, a')?.focus({ preventScroll: true });
        });
      });
    });

    scope.querySelectorAll('[data-filter-close]').forEach((button) => {
      if (button.dataset.bound === 'true') return;
      button.dataset.bound = 'true';
      button.addEventListener('click', () => closeFilterDrawer(button.closest('[data-filter-drawer]')));
    });

    scope.querySelectorAll('[data-filter-form]').forEach((form) => {
      const syncVisibility = () => {
        const isMobile = isMobileFilters();
        if (!isMobile && form.classList.contains('is-open')) {
          form.classList.remove('is-open');
          document.body.style.overflow = '';
        }
        form.setAttribute('aria-hidden', isMobile && !form.classList.contains('is-open') ? 'true' : 'false');
      };
      syncVisibility();

      if (form.dataset.autoFilterBound === 'true') return;
      form.dataset.autoFilterBound = 'true';
      let submitTimer = null;
      const handleResize = () => {
        if (!document.contains(form)) {
          window.removeEventListener('resize', handleResize);
          return;
        }
        syncVisibility();
      };
      window.addEventListener('resize', handleResize);

      const syncActiveInputs = () => {
        const params = new URLSearchParams(window.location.search);
        form.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach((input) => {
          if (!input.name) return;
          input.checked = params.getAll(input.name).includes(input.value);
        });
      };

      const prepareForm = () => {
        form.querySelectorAll('input[type="number"]').forEach((input) => {
          input.disabled = input.value.trim() === '';
        });
      };

      form.querySelectorAll('[data-filter-search]').forEach((input) => {
        input.addEventListener('input', () => {
          const query = input.value.trim().toLowerCase();
          const group = input.closest('.filter-group__values');
          if (!group) return;
          group.querySelectorAll('.filter-option').forEach((option) => {
            const label = option.textContent.toLowerCase();
            option.hidden = query !== '' && !label.includes(query);
          });
        });
      });

      const submitForm = (delay) => {
        window.clearTimeout(submitTimer);
        submitTimer = window.setTimeout(() => {
          prepareForm();
          form.requestSubmit();
        }, delay);
      };

      form.addEventListener('change', (event) => {
        const target = event.target;
        if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement)) return;
        if (target.matches('input[type="number"]')) {
          submitForm(450);
          return;
        }
        submitForm(0);
      });

      syncActiveInputs();

      form.addEventListener('input', (event) => {
        const target = event.target;
        if (!(target instanceof HTMLInputElement)) return;
        if (!target.matches('input[type="number"]')) return;
        submitForm(650);
      });

      form.addEventListener('submit', () => {
        prepareForm();
        form.classList.add('is-submitting');
      });
    });
  }

  function closeMobileMenu(menu) {
    if (!menu) return;
    const opener = document.querySelector(`[aria-controls="${menu.id}"]`);
    menu.classList.remove('is-open');
    resetMobileMenuPanels(menu);
    menu.setAttribute('aria-hidden', 'true');
    if (opener) opener.setAttribute('aria-expanded', 'false');
    const previousFocusSelector = menu.dataset.previousFocus;
    const previousFocus = previousFocusSelector ? document.querySelector(previousFocusSelector) : opener;
    if (previousFocus instanceof HTMLElement) previousFocus.focus({ preventScroll: true });
    delete menu.dataset.previousFocus;
    releasePageScrollIfNoOverlay();
  }

  function closeFilterDrawer(drawer) {
    if (!drawer) return;
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', isMobile ? 'true' : 'false');
    document.querySelectorAll(`[data-filter-open][aria-controls="${drawer.id}"]`).forEach((button) => {
      button.setAttribute('aria-expanded', 'false');
    });
    const previousFocusSelector = drawer.dataset.previousFocus;
    const previousFocus = previousFocusSelector ? document.querySelector(previousFocusSelector) : null;
    if (previousFocus instanceof HTMLElement) previousFocus.focus({ preventScroll: true });
    delete drawer.dataset.previousFocus;
    releasePageScrollIfNoOverlay();
  }

  function releasePageScrollIfNoOverlay() {
    if (
      document.querySelector('.mobile-menu.is-open') ||
      document.querySelector('.collection-filters.is-open') ||
      document.querySelector('cart-drawer.is-open')
    ) return;
    document.body.style.overflow = '';
  }

  function initDismissibleOverlays() {
    if (document.documentElement.dataset.dismissibleOverlaysBound === 'true') return;
    document.documentElement.dataset.dismissibleOverlaysBound = 'true';

    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      document.querySelectorAll('.mobile-menu.is-open').forEach((menu) => {
        if (menu.contains(target) || target.closest('[data-menu-open]')) return;
        closeMobileMenu(menu);
      });

      document.querySelectorAll('.collection-filters.is-open').forEach((drawer) => {
        if (drawer.contains(target) || target.closest('[data-filter-open]')) return;
        closeFilterDrawer(drawer);
      });

      releasePageScrollIfNoOverlay();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Tab') {
        const mobileMenu = document.querySelector('.mobile-menu.is-open');
        if (mobileMenu && trapFocus(event, mobileMenu)) return;
        const filterDrawer = document.querySelector('.collection-filters.is-open');
        if (filterDrawer && trapFocus(event, filterDrawer)) return;
      }

      if (event.key !== 'Escape') return;
      let dismissed = false;
      document.querySelectorAll('.mobile-menu.is-open').forEach((menu) => {
        closeMobileMenu(menu);
        dismissed = true;
      });
      document.querySelectorAll('.collection-filters.is-open').forEach((drawer) => {
        closeFilterDrawer(drawer);
        dismissed = true;
      });
      if (dismissed) {
        event.preventDefault();
        releasePageScrollIfNoOverlay();
      }
    });
  }

  function initCollectionView(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-collection-view-toggle]').forEach((toggle) => {
      if (toggle.dataset.bound === 'true') return;
      const collectionSection = toggle.closest('.main-collection');
      const products = toggle.closest('.main-collection__products')?.querySelector('[data-collection-products]');
      if (!products) return;
      toggle.dataset.bound = 'true';
      const buttons = toggle.querySelectorAll('[data-collection-view]');
      const setView = (view) => {
        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        products.classList.toggle('collection-grid', view === 'grid');
        products.classList.toggle('collection-list', view === 'list');
        collectionSection?.classList.toggle('is-list-view', view === 'list');
        collectionSection?.classList.toggle('is-grid-view', view === 'grid');
        buttons.forEach((button) => {
          const active = button.dataset.collectionView === view;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        if (isMobile) return;
        try {
          window.localStorage.setItem('indartxuCollectionView', view);
        } catch (error) {
          /* Storage can be unavailable in preview if blocked. */
        }
      };

      let storedView = null;
      try {
        storedView = window.localStorage.getItem('indartxuCollectionView');
      } catch (error) {
        storedView = null;
      }
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      setView(isMobile ? 'grid' : storedView === 'list' ? 'list' : products.classList.contains('collection-list') ? 'list' : 'grid');
      buttons.forEach((button) => {
        button.addEventListener('click', () => setView(button.dataset.collectionView));
      });
    });
  }

  function initAutoSubmitForms(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-auto-submit]').forEach((form) => {
      if (form.dataset.bound === 'true') return;
      form.dataset.bound = 'true';
      form.addEventListener('change', (event) => {
        const target = event.target;
        if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement)) return;
        form.requestSubmit();
      });
    });
  }

  function initFeaturedCarousels(root) {
    const scope = root || document;
    scope.querySelectorAll('.featured-products__carousel-wrap').forEach((wrap) => {
      if (wrap.dataset.bound === 'true') return;
      const carousel = wrap.querySelector('[data-featured-carousel]');
      const previous = wrap.querySelector('[data-featured-prev]');
      const next = wrap.querySelector('[data-featured-next]');
      if (!carousel || !previous || !next) return;

      wrap.dataset.bound = 'true';
      const updateOverflow = () => {
        window.requestAnimationFrame(() => {
          const hasOverflow = carousel.scrollWidth > carousel.clientWidth + 3;
          const isMobile = window.matchMedia('(max-width: 749px)').matches;
          wrap.classList.toggle(
            isMobile ? 'featured-products__carousel-wrap--no-mobile-nav' : 'featured-products__carousel-wrap--no-desktop-nav',
            !hasOverflow
          );
          previous.hidden = !hasOverflow;
          next.hidden = !hasOverflow;
        });
      };
      const scrollByPage = (direction) => {
        const distance = Math.max(carousel.clientWidth * .78, 160);
        const isLooping = carousel.hasAttribute('data-loop-carousel');
        if (isLooping) {
          const loopWidth = carousel.scrollWidth / 2;
          const maxScroll = carousel.scrollWidth - carousel.clientWidth;
          if (loopWidth > carousel.clientWidth && maxScroll > 0) {
            const jumpTo = (left) => {
              const previousScrollBehavior = carousel.style.scrollBehavior;
              carousel.style.scrollBehavior = 'auto';
              carousel.scrollLeft = left;
              carousel.style.scrollBehavior = previousScrollBehavior;
            };
            if (direction > 0 && carousel.scrollLeft + carousel.clientWidth + distance >= maxScroll) {
              jumpTo(Math.max(0, loopWidth - carousel.clientWidth));
            }
            if (direction < 0 && carousel.scrollLeft - distance <= 8) {
              jumpTo(maxScroll);
            }
          }
        }
        carousel.scrollBy({ left: distance * direction, behavior: 'smooth' });
      };

      previous.addEventListener('click', () => scrollByPage(-1));
      next.addEventListener('click', () => scrollByPage(1));
      window.addEventListener('resize', updateOverflow);
      if ('ResizeObserver' in window) {
        const resizeObserver = new ResizeObserver(updateOverflow);
        resizeObserver.observe(carousel);
      }
      updateOverflow();
    });
  }

  function initCollectionCatCarousels(root) {
    const scope = root || document;
    scope.querySelectorAll('.collection-cats__viewport').forEach((wrap) => {
      if (wrap.dataset.bound === 'true') return;
      const carousel = wrap.querySelector('[data-collection-cats-carousel]');
      const previous = wrap.querySelector('[data-collection-cats-prev]');
      const next = wrap.querySelector('[data-collection-cats-next]');
      if (!carousel || !previous || !next) return;

      wrap.dataset.bound = 'true';
      const persistPosition = () => {
        const collectionCats = wrap.closest('.collection-cats');
        const context = getCollectionCatsContext(collectionCats);
        writeCollectionCatsPosition(carousel, context.branch, context.group);
      };
      let scrollTimer = null;
      updateCollectionCatOverflow(wrap);
      const scrollByChip = (direction) => {
        const chip = carousel.querySelector('.collection-chip');
        const styles = window.getComputedStyle(carousel);
        const gap = Number.parseFloat(styles.columnGap || styles.gap || '0') || 0;
        const distance = chip ? chip.getBoundingClientRect().width + gap : carousel.clientWidth * .75;
        carousel.scrollBy({ left: distance * direction, behavior: 'smooth' });
      };

      previous.addEventListener('click', () => scrollByChip(-1));
      next.addEventListener('click', () => scrollByChip(1));
      carousel.addEventListener('scroll', () => {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(persistPosition, 120);
      }, { passive: true });
      window.addEventListener('pagehide', persistPosition);
      window.addEventListener('resize', () => updateCollectionCatOverflow(wrap));
    });
  }

  function initAdviceCarousels(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-advice-strip]').forEach((wrap) => {
      if (wrap.dataset.bound === 'true') return;
      const carousel = wrap.querySelector('[data-advice-carousel]');
      const previous = wrap.querySelector('[data-advice-prev]');
      const next = wrap.querySelector('[data-advice-next]');
      if (!carousel || !previous || !next) return;

      const sourceItems = Array.from(carousel.querySelectorAll('.product-strip__item'));
      if (sourceItems.length < 2) {
        previous.hidden = true;
        next.hidden = true;
        return;
      }

      wrap.dataset.bound = 'true';
      const templates = sourceItems.map((item) => item.cloneNode(true));
      let cycleWidth = 0;
      let step = 0;
      let resizeTimer = null;
      let scrollFrame = null;

      const setCloneAccessibility = (item, hidden) => {
        if (!hidden) return item;
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
        item.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((element) => {
          element.setAttribute('tabindex', '-1');
        });
        return item;
      };

      const createCycle = (repeatCount, hidden) => {
        const fragment = document.createDocumentFragment();
        for (let repeatIndex = 0; repeatIndex < repeatCount; repeatIndex += 1) {
          templates.forEach((template) => {
            const clone = template.cloneNode(true);
            clone.dataset.adviceLoopItem = 'true';
            fragment.appendChild(setCloneAccessibility(clone, hidden || repeatIndex > 0));
          });
        }
        return fragment;
      };

      const jumpTo = (left) => {
        const previousBehavior = carousel.style.scrollBehavior;
        carousel.style.scrollBehavior = 'auto';
        carousel.scrollLeft = left;
        carousel.style.scrollBehavior = previousBehavior;
      };

      const buildLoop = () => {
        carousel.replaceChildren(createCycle(1, false));
        const measuredItems = Array.from(carousel.children);
        const first = measuredItems[0]?.getBoundingClientRect();
        const last = measuredItems[measuredItems.length - 1]?.getBoundingClientRect();
        const styles = window.getComputedStyle(carousel);
        const gap = Number.parseFloat(styles.columnGap || styles.gap || '0') || 0;
        const sourceWidth = first && last ? Math.max(last.right - first.left + gap, first.width + gap) : carousel.clientWidth;
        const itemStep = first ? first.width + gap : 0;
        const repeatCount = Math.max(1, Math.ceil((carousel.clientWidth + itemStep * 2) / sourceWidth));
        const cycleItemCount = templates.length * repeatCount;

        carousel.replaceChildren(
          createCycle(repeatCount, true),
          createCycle(repeatCount, false),
          createCycle(repeatCount, true)
        );

        const loopItems = Array.from(carousel.children);
        cycleWidth = loopItems[cycleItemCount]?.offsetLeft - loopItems[0]?.offsetLeft;
        step = loopItems[1]?.offsetLeft - loopItems[0]?.offsetLeft || itemStep;
        jumpTo(cycleWidth);
        previous.hidden = false;
        next.hidden = false;
      };

      const normalizePosition = () => {
        scrollFrame = null;
        if (!cycleWidth) return;
        const left = carousel.scrollLeft;
        if (left < cycleWidth * .5) jumpTo(left + cycleWidth);
        if (left > cycleWidth * 1.5) jumpTo(left - cycleWidth);
      };

      const scrollOne = (direction) => {
        if (!step) return;
        carousel.scrollBy({ left: step * direction, behavior: 'smooth' });
      };

      previous.addEventListener('click', () => scrollOne(-1));
      next.addEventListener('click', () => scrollOne(1));
      carousel.addEventListener('scroll', () => {
        if (scrollFrame !== null) return;
        scrollFrame = window.requestAnimationFrame(normalizePosition);
      }, { passive: true });
      window.addEventListener('resize', () => {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(buildLoop, 120);
      });
      buildLoop();
    });
  }

  function initAddressCountries(root) {
    const scope = root || document;
    scope.querySelectorAll('select[name="address[country]"]').forEach((select) => {
      if (select.dataset.bound === 'true') return;
      select.dataset.bound = 'true';
      const defaultCountry = select.dataset.default;
      if (defaultCountry) {
        Array.from(select.options).forEach((option) => {
          option.selected = option.value === defaultCountry || option.text === defaultCountry;
        });
      }

      const provinceSelect = select.dataset.provinceTarget
        ? document.getElementById(select.dataset.provinceTarget)
        : null;
      const provinceWrapper = provinceSelect?.closest('[data-address-province-wrapper]');
      const defaultProvince = provinceSelect?.dataset.default || '';

      const updateProvinceOptions = () => {
        if (!provinceSelect || !provinceWrapper) return;
        const selectedOption = select.options[select.selectedIndex];
        let provinces = [];
        try {
          provinces = JSON.parse(selectedOption?.dataset.provinces || '[]');
        } catch (error) {
          provinces = [];
        }

        provinceSelect.innerHTML = '';
        if (!provinces.length) {
          provinceSelect.disabled = true;
          provinceWrapper.hidden = true;
          return;
        }

        provinces.forEach((province) => {
          const option = document.createElement('option');
          option.value = province[0];
          option.textContent = province[1];
          option.selected = province[0] === defaultProvince || province[1] === defaultProvince;
          provinceSelect.append(option);
        });
        provinceSelect.disabled = false;
        provinceWrapper.hidden = false;
      };

      select.addEventListener('change', updateProvinceOptions);
      updateProvinceOptions();
    });
  }

  function initConfirmForms(root) {
    const scope = root || document;
    scope.querySelectorAll('form[data-confirm-message]').forEach((form) => {
      if (form.dataset.bound === 'true') return;
      form.dataset.bound = 'true';
      form.addEventListener('submit', (event) => {
        const message = form.dataset.confirmMessage;
        if (message && !window.confirm(message)) {
          event.preventDefault();
        }
      });
    });
  }

  function initCustomerRecover(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-customer-recover]').forEach((details) => {
      if (!(details instanceof HTMLDetailsElement)) return;
      const shouldOpen = window.location.hash === '#recover' || details.querySelector('.form-error, .form-status');
      if (shouldOpen) details.open = true;
    });
  }

  function initPredictiveSearch(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-predictive-search]').forEach((form) => {
      if (form.dataset.bound === 'true') return;
      const input = form.querySelector('[data-predictive-search-input]');
      const results = form.querySelector('[data-predictive-search-results]');
      if (!input || !results) return;

      form.dataset.bound = 'true';
      let searchTimer = null;
      let controller = null;
      let activeSearchId = 0;
      const resultLimit = Math.max(3, Math.min(8, Number(form.dataset.predictiveLimit || 4)));

      const hideResults = () => {
        activeSearchId += 1;
        if (controller) {
          controller.abort();
          controller = null;
        }
        results.hidden = true;
        results.innerHTML = '';
        form.setAttribute('aria-busy', 'false');
        input.setAttribute('aria-expanded', 'false');
      };

      const renderResults = (products) => {
        const label = form.dataset.predictiveLabel || '';
        const emptyText = form.dataset.predictiveEmpty || '';
        if (!products.length) {
          results.innerHTML = `<p class="search-page__predictive-empty" role="status">${escapeHTML(emptyText)}</p>`;
          results.hidden = false;
          input.setAttribute('aria-expanded', 'true');
          return;
        }

        results.innerHTML = `
          ${label ? `<p class="search-page__predictive-label">${escapeHTML(label)}</p>` : ''}
          <div class="search-page__predictive-list">
            ${products.map((product, index) => `
              <a class="search-page__predictive-item" href="${escapeHTML(product.url)}" role="option" id="${escapeHTML(results.id || 'PredictiveSearch')}-option-${index}">
                <span class="search-page__predictive-media">
                  ${product.image ? `<img src="${escapeHTML(product.image)}" alt="" loading="lazy">` : ''}
                </span>
                <span class="search-page__predictive-title">${escapeHTML(product.title)}</span>
              </a>
            `).join('')}
          </div>
        `;
        results.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      };

      input.addEventListener('input', () => {
        window.clearTimeout(searchTimer);
        const query = input.value.trim();
        if (query.length < 2) {
          if (controller) controller.abort();
          hideResults();
          return;
        }

        searchTimer = window.setTimeout(async () => {
          if (controller) controller.abort();
          controller = new AbortController();
          const searchId = activeSearchId + 1;
          activeSearchId = searchId;
          form.setAttribute('aria-busy', 'true');
          try {
            const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=${resultLimit}`, {
              signal: controller.signal,
              headers: { Accept: 'application/json' }
            });
            if (!response.ok) return;
            const data = await response.json();
            if (activeSearchId !== searchId) return;
            if (input.value.trim() !== query) return;
            renderResults(data.resources?.results?.products || []);
          } catch (error) {
            if (error.name !== 'AbortError') hideResults();
          } finally {
            if (activeSearchId === searchId) {
              form.setAttribute('aria-busy', 'false');
              controller = null;
            }
          }
        }, 300);
      });

      input.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        hideResults();
      });

      const handleDocumentClick = (event) => {
        if (!document.contains(form)) {
          document.removeEventListener('click', handleDocumentClick);
          return;
        }
        if (event.target instanceof Element && form.contains(event.target)) return;
        hideResults();
      };
      document.addEventListener('click', handleDocumentClick);
    });
  }

  function initProductTabs(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-product-tabs]').forEach((tabs) => {
      if (tabs.dataset.bound === 'true') return;
      const buttons = Array.from(tabs.querySelectorAll('[data-product-tab]'));
      const panels = Array.from(tabs.querySelectorAll('[data-product-tab-panel]'));
      if (!buttons.length || !panels.length) return;

      tabs.dataset.bound = 'true';

      const activateTab = (button, shouldFocus = false) => {
        const targetId = button.dataset.productTabTarget;
        buttons.forEach((item) => {
          const isActive = item === button;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-selected', isActive ? 'true' : 'false');
          item.setAttribute('tabindex', isActive ? '0' : '-1');
        });

        panels.forEach((panel) => {
          const isActive = panel.id === targetId;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });

        if (shouldFocus) button.focus({ preventScroll: true });
      };

      buttons.forEach((button, index) => {
        button.addEventListener('click', () => activateTab(button));
        button.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowUp', 'ArrowRight', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let nextIndex = index;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = index === 0 ? buttons.length - 1 : index - 1;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = index === buttons.length - 1 ? 0 : index + 1;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = buttons.length - 1;
          activateTab(buttons[nextIndex], true);
        });
      });

      const selected = buttons.find((button) => button.getAttribute('aria-selected') === 'true') || buttons[0];
      activateTab(selected);
    });
  }

  function initProductDescriptionLinks(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-product-description-link]').forEach((link) => {
      if (link.dataset.bound === 'true') return;
      link.dataset.bound = 'true';

      link.addEventListener('click', (event) => {
        const tabs = document.querySelector('[data-product-tabs]');
        if (!tabs) return;

        event.preventDefault();

        const descriptionTab = tabs.querySelector('[data-product-description-tab]');
        const descriptionDetails = tabs.querySelector('[data-product-description-details]');
        const descriptionPanel = tabs.querySelector('[data-product-description-panel]');
        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        const target = isMobile ? descriptionDetails || descriptionPanel || tabs : descriptionPanel || descriptionDetails || tabs;

        if (descriptionTab instanceof HTMLElement) {
          descriptionTab.click();
        }

        if (descriptionDetails instanceof HTMLDetailsElement) {
          tabs.querySelectorAll('.product-tabs__mobile-accordions details').forEach((details) => {
            details.open = details === descriptionDetails;
          });
        }

        const targetTop = target.getBoundingClientRect().top + window.scrollY - 150;
        window.scrollTo({ top: Math.max(targetTop, 0), behavior: 'smooth' });
      });
    });
  }

  function init(root) {
    initInputMode();
    initMobileMenu(root);
    initMobileMenuPanels(root);
    initFooterAccordions(root);
    initQuantity(root);
    initFilters(root);
    initCollectionView(root);
    initAutoSubmitForms(root);
    initMenuContextTracking(root);
    initCollectionMenuContext(root);
    initFeaturedCarousels(root);
    initCollectionCatCarousels(root);
    initAdviceCarousels(root);
    initAddressCountries(root);
    initConfirmForms(root);
    initCustomerRecover(root);
    initPredictiveSearch(root);
    initProductTabs(root);
    initProductDescriptionLinks(root);
    initDismissibleOverlays();
  }

  document.addEventListener('DOMContentLoaded', () => init(document));
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('.mobile-menu.is-open, .collection-filters.is-open').forEach((element) => {
      if (element.matches('.mobile-menu')) {
        closeMobileMenu(element);
      } else {
        closeFilterDrawer(element);
      }
    });
    document.body.style.overflow = '';
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.mobile-menu.is-open, .collection-filters.is-open').forEach((element) => {
      if (element.matches('.mobile-menu')) {
        closeMobileMenu(element);
      } else {
        closeFilterDrawer(element);
      }
    });
    document.querySelector('cart-drawer')?.close?.();
    releasePageScrollIfNoOverlay();
  });
})();
